import type { PmDTO } from '../shared/social.ts';
import type { ServerEvent } from '../shared/events.ts';
import type { StoreAdmin } from '../shared/diamond-packs.ts';
import type { DiamondReport } from '../shared/diamond-ledger.ts';
import type { StreamsAdmin } from '../shared/streams.ts';
import type { ExchangeAdmin, ExchangeDTO } from '../shared/exchange.ts';
import type { Broadcast, CreatureDTO, FieldDTO, ListingDTO, MarketDTO, TrainerDTO, BossResult, LadderResult, FastForwardSummary, GemAdmin } from '../shared/protocol.ts';
import type { TrailFightDTO } from '../shared/trail.ts';

export const S = {
  trainer: null as TrainerDTO | null,
  creatures: new Map<number, CreatureDTO>(),
  field: null as FieldDTO | null,
  prevField: null as FieldDTO | null,
  fieldAt: 0,
  /** server time minus client time */
  skew: 0,
  broadcasts: [] as Broadcast[],
  market: null as MarketDTO | null,
  admin: null as null | { econ: { hour: number; mint: Record<string, number>; burn: Record<string, number> }[]; accounts: number; online: number; prices: Record<string, number[]>; log: { ts: number; action: string; data: string }[]; ffMax: number; events?: ServerEvent[]; store?: StoreAdmin; streams?: StreamsAdmin; founderOpen?: boolean; synergyOn?: boolean; boardOn?: boolean; exchange?: ExchangeAdmin; heldOn?: boolean; trailOn?: boolean; diamonds?: DiamondReport; gems?: GemAdmin; ranked?: { on: boolean; season: number; endsAt: number; theme: string; players: number; strength?: boolean }; tour?: { on: boolean; launch: number | null }; reports?: { id: number; ts: number; reporter: string; target: string; lines: PmDTO[] }[] },
  /** Last admin fast-forward result. */
  lastFF: null as FastForwardSummary | null,
  boss: null as BossResult | null,
  /** The last Boss Ladder fight (client/ladder.ts). */
  ladder: null as LadderResult | null,
  /** The page in the address (#/map → 'map'); 'hunt' when the hunt shows. */
  page: 'hunt' as string,
  /** The pane the page shows, or '' on the hunt. Set from the route only. */
  tab: '' as string,
  depotSort: 'recent' as 'recent' | 'rating' | 'power' | 'level' | 'species',
  depotFilter: '',
  /** A listing to show on the Market page (#/market/:id, from a Trade card), or 0. */
  marketFocus: 0,
  mapRegion: 'midgard' as string,
  /** The map's rate: XP or coins per hour, or the hunt level. The hunt suggestion follows it. */
  mapMetric: 'xp' as 'xp' | 'coins' | 'level',
  dexSpecies: '' as string,
  /** all, collection (favorites) or listed (for sale). */
  depotView: 'all' as string,
  online: false,
  /** Players connected to the server, from hello and every 30 s; 0 until known. */
  playersOnline: 0,
  /** Whether the Founder Box is on sale (shared/founder.ts). */
  founderOpen: false,
  /** Whether ranked seasons are on (shared/ranked.ts): the Arena opens at Lv 40 and plays the trophy ladder. */
  ranked: false,
  /** Season one switches from the server: held items in PvP (shared/held.ts) and the Trail (shared/trail.ts). */
  heldOn: true,
  trailOn: true,
  /** The last Trail trainer fight (client/trail.ts). */
  trailFight: null as TrailFightDTO | null,
};

export function serverNow() { return Date.now() + S.skew; }
